import { Action, createReducer, on } from '@ngrx/store';
import * as OidcSignupActions from './oidc-signup.actions';

export const OIDC_SIGNUP_FEATURE_KEY = 'oidcSignup';

export interface OidcSignupState {
    loading: boolean;
    done: boolean;
    error: any;
}

export const OIDC_SIGNUP_INITIAL_STATE: OidcSignupState = {
    loading: false,
    done: false,
    error: null
};

const oidcSignupReducerInternal = createReducer(
    OIDC_SIGNUP_INITIAL_STATE,
    on(OidcSignupActions.completeSignup, (state: OidcSignupState) => ({
        ...state,
        loading: true,
        done: false,
        error: null
    })),
    on(OidcSignupActions.completeSignupSuccess, (state: OidcSignupState) => ({
        ...state,
        loading: false,
        done: true,
        error: null
    })),
    on(OidcSignupActions.completeSignupFailed, (state: OidcSignupState, { payload }) => ({
        ...state,
        loading: false,
        done: false,
        error: payload
    })),
    on(OidcSignupActions.completeSignupReset, () => ({
        ...OIDC_SIGNUP_INITIAL_STATE
    }))
);

export function oidcSignupReducer(state: OidcSignupState | undefined, action: Action): OidcSignupState {
    return oidcSignupReducerInternal(state, action);
}
